<template>
  <div id="app" class="max-w-screen-sm mx-auto bg-gray-50 min-h-screen">
    <div id="nav"></div>
    <transition name="view">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  methods: {
    addScript() {
      // Helps with cache issues that comes with firebase. Feel free to adjust as you see fit.
      var scripts = document.getElementsByTagName('script')
      scripts.forEach(script => {
        if (script.src.includes('app')) {
          var jsfile = script.src
          if (localStorage.getItem('jsfile') != jsfile) {
            localStorage.setItem('jsfile', script.src)
            indexedDB.deleteDatabase('firebaseLocalStorageDb')
            window.location.reload(true)
          }
        }
      })
    }
  },
  mounted() {
    this.addScript()
  }
}
</script>

<style>
.view-enter-active,
.view-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease-in-out;
}

.view-enter-active {
  transition-delay: 0.5s;
}

.view-enter {
  opacity: 0;
  transform: translateX(100px);
}

.view-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}

.view-leave {
  opacity: 1;
  transform: translateX(0px);
}

.view-enter-to {
  opacity: 1;
  transform: translateX(0px);
}
</style>
